// src/utils/dominioAziendale.js
// Riconosce se un indirizzo email appartiene a un dominio aziendale vero — usato per
// suggerire "la tua azienda è già su Nexiora, vuoi unirti?" invece di far scoprire il
// duplicato solo dopo, sulla P.IVA. Non sostituisce mai l'approvazione del Titolare
// (ogni nuovo iscritto nasce comunque enabled:false) — riduce solo l'attrito di dover
// chiedere/passare un codice invito a mano.
//
// Esclusione deliberata dei provider gratuiti/generici: riconoscerli sarebbe pericoloso,
// non utile — chiunque con un indirizzo Gmail qualsiasi si vedrebbe proposta un'azienda a
// caso solo perché il fondatore ha usato Gmail per registrarsi.
const PROVIDER_GENERICI = new Set([
  "gmail.com", "googlemail.com", "outlook.com", "outlook.it", "hotmail.com", "hotmail.it",
  "yahoo.com", "yahoo.it", "libero.it", "virgilio.it", "alice.it", "tin.it", "tiscali.it",
  "icloud.com", "msn.com", "aol.com", "live.com", "live.it", "fastwebnet.it", "email.it",
  "inwind.it", "gmx.com", "gmx.it", "protonmail.com", "pec.it",
]);

export function dominioDaEmail(email) {
  const match = (email||"").trim().toLowerCase().match(/@([a-z0-9.-]+\.[a-z]{2,})$/);
  return match ? match[1] : null;
}

// Da usare solo al momento della creazione di una nuova organizzazione — se il dominio è
// generico, restituisce null: quell'organizzazione semplicemente non partecipa al
// riconoscimento automatico (nessun problema, resta comunque raggiungibile col codice invito).
export function dominioAziendaleValido(email) {
  const dominio = dominioDaEmail(email);
  if (!dominio || PROVIDER_GENERICI.has(dominio)) return null;
  return dominio;
}
